import get from "lodash.get";

export default function safeReduxStateNetworkErrorObject(result) {
    if(!result) return {}
    return {
        status: result.status,
        value: {
            name: get(result, 'reason.name'),
            status: get(result, 'reason.status.message') || 'network failure'
        }
    }
}